<template>
    <MasterDetailLayout :loading="loading">
        <!-- Sidebar -->
        <template v-slot:sidebar>
            <slot name="sidebar" />
        </template>
        <!-- Header -->
        <template v-slot:header>
            <div class="header-wrap">
                <div v-if="abEnabled" class="ab-indicator" :class="{'is-a': abValueIsA}"></div>
                <slot name="header" />
                <div class="header-buttons">
                    <button class="ssa-button headlineSmall" @click="$emit('newSegmentClicked')" >
                        New Segment
                    </button>
                </div>
            </div>
        </template>
        <!-- Content -->
        <template v-slot:content>
            <div class="no-data-overlay" v-if="empty">
                <span class="font-1">No Segments Defined</span>
                <p class="font-4">To get started click 'New Segment'</p>
            </div>
            <slot v-else name="content" />
        </template>
    </MasterDetailLayout>
</template>

<script>
import MasterDetailLayout from 'components/pageLayouts/MasterDetailLayout.vue';

export default {
    name: 'SegmentsSetupLayout',
    components: { MasterDetailLayout },
    props: {
        loading: Boolean,
        empty: Boolean,
        abEnabled: Boolean,
        abValueIsA: Boolean
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";
@import "~styles/buttons.scss";

.header-wrap {
    display: flex;
    position: relative;
    padding-right: 15px;
    > .header-buttons {
        display: flex;
        align-items: center;
    }
}

.no-data-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: $light-700;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > p {
        margin: 5px 0 0 0;
    }
}

.ab-indicator {
    position: absolute;
    top: 0;
    background-color: $abColorB;
    width: 100%;
    height: 2px;
    &.is-a {
        background-color: $abColorA;
    }
}
</style>
